import React, { useCallback, useId } from 'react'
import LoadingSpinner from '../../ui/LoadingSpinner'
import { deviceNames } from '../../../utils/deviceDefinitions'

const DeviceSelector = React.memo(({ selectedDevices, onChange, availableDevices, loading, error }) => {
  const baseId = useId()

  const handleDeviceChange = useCallback((device, isChecked) => {
    onChange(
      isChecked
        ? [...selectedDevices, device]
        : selectedDevices.filter(d => d !== device),
    )
  }, [selectedDevices, onChange])

  const handleSelectAllDevices = useCallback(() => {
    if (availableDevices.length === selectedDevices.length) {
      onChange([]) // Deselect all
    } else {
      onChange(availableDevices) // Select all
    }
  }, [availableDevices, selectedDevices, onChange])

  if (loading) return <LoadingSpinner message="Loading devices..." />

  const allDevicesSelected = availableDevices.length > 0 && availableDevices.length === selectedDevices.length

  return (
    <div className="device-selector">
      <div className="d-flex align-items-center mb-3">
        <h6 className="mb-0 fw-bold">Select Devices:</h6>
        {availableDevices.length > 0 && (
          <button
            className="btn btn-outline-secondary btn-sm ms-3"
            onClick={handleSelectAllDevices}
            disabled={availableDevices.length === 0}
          >
            <i className="bi bi-check-all me-1"></i>
            {allDevicesSelected ? 'Deselect All' : 'Select All'}
          </button>
        )}
      </div>
      {error && <div className="alert alert-warning py-2 mb-2"><i className="bi bi-exclamation-triangle me-2"></i>{error}</div>}
      <div className="d-flex flex-wrap gap-2">
        {availableDevices.length > 0 ? availableDevices.map(device => (
          <React.Fragment key={device}>
            <input
              type="checkbox"
              className="btn-check"
              id={`${baseId}-${device}`}
              checked={selectedDevices.includes(device)}
              onChange={e => handleDeviceChange(device, e.target.checked)}
              autoComplete="off"
            />
            <label
              className={`btn btn-sm ${selectedDevices.includes(device) ? 'btn-primary' : 'btn-outline-primary'}`}
              htmlFor={`${baseId}-${device}`}
            >
              {deviceNames[device] || device}
            </label>
          </React.Fragment>
        )) : (
          <div className="text-muted">No devices available</div>
        )}
      </div>
    </div>
  )
})

DeviceSelector.displayName = 'DeviceSelector'

export default DeviceSelector